import { getTenantHomeUrl } from './tenantUrl';

export const goToHome = (): void => {
  window.location.replace(getTenantHomeUrl());
};
